export const eulaVersion = '2023-11-21';
